// ResponsiveServices.jsx → src/gestion-services/
import React from "react";
import GestionServices from "./GestionServices";
import ServicesMobile from "../mobile/produits/ServicesMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveServices(props) {
  return useIsMobile() ? <ServicesMobile {...props} /> : <GestionServices {...props} />;
}
